// removed by extract-text-webpack-plugin
module.exports = {"module":"c-CheckoutMembershipModule__module","label":"c-CheckoutMembershipModule__label","name":"c-CheckoutMembershipModule__name","logout":"c-CheckoutMembershipModule__logout"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/CheckoutMembershipModule/CheckoutMembershipModule.scss
// module id = 1114
// module chunks = 0